var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag || 'div',_vm._b({tag:"component",staticClass:"c_icon_svg",domProps:{"innerHTML":_vm._s(_vm.svgHtml || null)},on:{"click":function($event){return _vm.$emit('click')}}},'component',_vm.svgAttributes,false))
}
var staticRenderFns = []

export { render, staticRenderFns }